import React from "react"

import { ProductPositionMultiSelectSidebar } from "pages/project-page/sidebar/multi/product-position/ProductPositionMultiSelectSidebar"
import {
  UseProductPositionMultiSelectSidebarModelArgs,
  useProductPositionMultiSelectSidebarModel
} from "pages/project-page/sidebar/multi/product-position/hooks/useProductPositionMultiSelectSidebarModel"

export const SharedProjectPageProductPositionMultiSelectSidebarConnector =
  React.memo((props: UseProductPositionMultiSelectSidebarModelArgs) => (
    <ProductPositionMultiSelectSidebar
      {...useProductPositionMultiSelectSidebarModel(props)}
      hideControls
    />
  ))
